import { render } from "./MCheckbox.vue?vue&type=template&id=44c19f54&scoped=true"
import script from "./MCheckbox.vue?vue&type=script&lang=js"
export * from "./MCheckbox.vue?vue&type=script&lang=js"

import "./MCheckbox.vue?vue&type=style&index=0&id=44c19f54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c19f54"]])

export default __exports__